import React, { useState, useEffect } from 'react';

import { ContentBox } from "../../ContentBox"
import { SystemPromptInput } from '../../../Res/SystemPrompt';
import { EnableBadge, AddButton, Space, DisableBadge } from '../../../Res/BaseButton';
import 'rc-datepicker/lib/style.css';
import moment from 'moment';
import { ManagementPrompt } from '../../../Res/ManagementPrompt';
import { setVal2Token, getval2Token } from '../../../../Login/Auth';

import { SELECT_VAL_TYPE_INT, SELECT_VAL_TYPE_STRING } from '../../../Res/BaseInput';
import { BaseSearchBox } from '../../../Res/BaseSearch';
import { SearchInput, SearchSelect } from '../../../../../item/ItemSearch';
import { api_getTeamList } from '../../../../../api/MyStat/apiTeam';
import { TableListTitle, setTD, setTDLink, ListBox } from '../../../../../item/ItemTableList';
import { ReqTeamList } from '../../../../../item/MyStat/ItemTeam';
import { ACTIVATION_ENABLE, search_activation_attr, get_activation_string, get_activation_color, ACTIVATION_DISABLE } from '../../../../../item/MyStat/ItemMyStatBase';
import { ReqLeagueList } from '../../../../../item/MyStat/ItemLeague';
import { api_getLeagueListEnable } from '../../../../../api/MyStat/apiLeague';

export function TeamList({ id, setIsLoading }) {
    const [tokenId, setTokenId] = useState("")
    const [league_association_arr, set_league_association_arr] = useState(undefined)

    const [team_name, set_team_name] = useState("")
    const [league_association, set_league_association] = useState("")
    const [team_activation, set_team_activation] = useState(ACTIVATION_ENABLE)

    const [searchItems, setSearchItems] = useState([])

    const [teamList, setTeamList] = useState([])
    const [page, setPage] = useState(1)
    const [limit] = useState(10)
    const [count, setCount] = useState(0)
    const [enableCount, setEnableCount] = useState(0)
    const [disableCount, setDisableCount] = useState(0)

    // const [mReqTeamList, setReqTeamList] = useState({})

    const [list_obj, set_list_obj] = useState({})

    const [searchItem, set_searchItem] = useState()

    useEffect(() => {
        get_league_association()
    }, [])
    useEffect(() => {
        if (league_association_arr !== undefined)
            var searchItems = [
                [
                    new SearchInput({
                        key: 'team_name',
                        val: team_name,
                        defaultVal: '',
                        title: '以中文名稱搜尋',
                        col: 4
                    }),
                    new SearchSelect({
                        key: 'league_association',
                        val: league_association,
                        defaultVal: "",
                        valType: SELECT_VAL_TYPE_STRING,
                        title: '所屬聯盟',
                        col: 4,
                        attr: league_association_arr
                    }),
                    new SearchSelect({
                        key: 'team_activation',
                        val: team_activation,
                        defaultVal: ACTIVATION_ENABLE,
                        valType: SELECT_VAL_TYPE_INT,
                        title: '狀態',
                        col: 4,
                        attr: search_activation_attr
                    })
                ],
                // new SearchBrLine()
            ]
        setSearchItems(searchItems)
    }, [league_association_arr, team_name, team_activation, league_association])

    useEffect(() => {
        if (id !== undefined && id !== tokenId && league_association_arr !== undefined) {
            var url = getval2Token("url", id)
            console.log(url)
            setTokenId(id)
            var start = (url.page - 1) * limit;
            var mReqTeamList = new ReqTeamList({ start, limit })
            if (url === "") {
                toSearch({ searchItem: mReqTeamList, page: url.page })
            } else {
                mReqTeamList.fromJson(url)
                console.log("mReqTeamList")
                console.log(mReqTeamList)
                set_team_name(mReqTeamList.team_name)
                set_league_association(mReqTeamList.league_association)
                set_team_activation(mReqTeamList.team_activation)
                toSearch({ searchItem: mReqTeamList, page: url.page })
            }
        }
    }, [id, league_association_arr])

    useEffect(() => {
        var contents = []
        teamList.forEach(item => {
            // console.log(item)
            var content = []
            content.push(setTD({ content: item._id }))
            content.push(setTDLink({ link: 'Team_Detail', content: item.team_name, key: 'TeamEdit', val: item }))
            content.push(setTD({ content: item.total_players }))
            content.push(setTD({ content: item.league_name }))
            content.push(setTD({ content: moment(item.logo_team_date).format('YYYY-MM-DD') }))
            content.push(setTD({ content: get_activation_string(item.team_activation), color: get_activation_color(item.team_activation) }))
            contents.push(content)
        })
        // console.log(contents)
        var lb = {
            titles: [
                new TableListTitle('編號', 1),
                new TableListTitle('中文名稱', 4),
                new TableListTitle('球員總數', 2),
                new TableListTitle('所屬聯盟', 2),
                new TableListTitle('異動日期', 2),
                new TableListTitle('狀態', 2),
            ],
            contents
        }

        set_list_obj(lb)

    }, [teamList])


    function get_league_association() {
        if (setIsLoading !== undefined)
            setIsLoading(true)
        api_getLeagueListEnable({
            success: (obj) => {
                var arr = [{ val: "", name: "全部" }]
                obj.list.forEach(item => {
                    arr.push({ val: item.league_id, name: item.league_name })
                })
                // console.log(arr)
                set_league_association_arr(arr)
                if (setIsLoading !== undefined)
                    setIsLoading(false)
            },
            failure: (err) => {
                if (setIsLoading !== undefined)
                    setIsLoading(false)
            }
        })
    }

    function toActionSearch(searchItems) {
        // console.log(searchItems)
        var mReqTeamList = new ReqTeamList({})
        searchItems.forEach((boxItem) => {
            if (Array.isArray(boxItem)) {
                boxItem.forEach(item => {
                    mReqTeamList[item.key] = item.val
                })
            }
        })
        // console.log(mReqTeamList)
        setSearchItems(searchItems)
        toSearch({ searchItem: mReqTeamList })
    }

    function toSearch({ searchItem, page = 1 }) {
        //console.log("toSearch")

        // console.log(items)
        var start = (page - 1) * limit;
        setPage(page)
        var mReqTeamList = new ReqTeamList({ start, limit, page })
        if (searchItem !== undefined){
            mReqTeamList.fromJson(searchItem)
            mReqTeamList.start = start
            mReqTeamList.limit = limit
        }
        // setReqLeagueList(mReqLeagueList)
        set_searchItem(mReqTeamList)
        // if(items === undefined){
        //     var url = getval2Token("url", id)
        //     if (url === "") {
        //     } else {
        //         mReqTeamList.fromJson(url)
        //         mReqTeamList.start = start
        //         console.log("mReqTeamList")
        //         console.log(mReqTeamList)
        //         set_team_name(mReqTeamList.team_name)
        //         set_league_association(mReqTeamList.league_association)
        //     }
        // }else{
        //     mReqTeamList.fromJson(items)
        // }
        set_team_activation(mReqTeamList.team_activation)

        setVal2Token("url", mReqTeamList, id)
        getTeamList(mReqTeamList)
    }

    function getTeamList(mReqTeamList) {
        if (setIsLoading !== undefined)
            setIsLoading(true)
        // console.log(mReqTeamList)
        api_getTeamList({
            mReqTeamList,
            success: (obj) => {
                console.log(obj)
                setTeamList(obj.list)
                setCount(obj.count)
                setEnableCount(obj.enableCount)
                setDisableCount(obj.disableCount)
                setIsLoading(false)
            },
            failure: (err) => {
                console.log(err)
                setIsLoading(false)
                //window.location.replace("/AdminManagerList");
            }
        })
    }

    function toAdd() {
        window.location.assign("/Team_Add");
    }

    var baseTitle = "球隊列表"
    var baseContent =
        <>
            <div className="row">
                <div className="col-sm-12">
                    <EnableBadge text={"啟用"} count={enableCount} />
                    <DisableBadge text={"停用"} count={disableCount} />
                    <AddButton name={"新增"} action={toAdd} />
                </div>
            </div>
            <Space />
            <ListBox row={6} lb={list_obj} srl={setTeamList} count={team_activation === ACTIVATION_ENABLE ? enableCount : team_activation === ACTIVATION_DISABLE ? disableCount : count} page={page} sp={toSearch} />
        </>
    return (
        <>
            <BaseSearchBox action={toActionSearch} items={searchItems} />
            <ContentBox title={baseTitle} content={baseContent} hasDrawer={true} />
            <ManagementPrompt />
            <SystemPromptInput />
        </>
    )
}

